import { useEffect, useState } from "react";
import { Switch } from "@headlessui/react";
import { fetchWithAuth } from "../../utils/apiUtils";
import { SettingsLayout } from "./settings-layout";
import { classNames } from "../../utils/classNamesUtils";
import { useTranslation } from "react-i18next";

export function CompanySettingsPage() {
  const [autoAcceptJobs, setAutoAcceptJobs] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const { t } = useTranslation();

  const saveSettings = async () => {
    setIsSaving(true);

    // 
    const companyResults = await fetchWithAuth('identity/organization', {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        autoAcceptJobs: autoAcceptJobs,
      }),
    })

    setIsSaving(false);
  };

  const getSettings = async () => {
    console.log('CALLED GET');
    const companyResults = await fetchWithAuth('identity/organization', {
      method: "GET",
    });

    if (companyResults.status === 200) {
      const companySettings = await companyResults.json();
      setAutoAcceptJobs(companySettings.autoAcceptJobs);
    }
  }

  useEffect(() => {
    getSettings();
  }, []);


  return (
    <SettingsLayout>
      <div className="py-6 px-4 sm:p-6 lg:pb-8">
        <div>
          <h2 className="text-lg font-medium leading-6 text-gray-900">
            {t('settings.companySettings')}
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            {t('settings.companySettingsDesc')}
          </p>
        </div>
      </div>

      {/* Privacy section */}
      <div className="divide-y divide-gray-200 pt-6">
        <div className="px-4 sm:px-6">
          {/* <div>
                      <h2 className="text-lg font-medium leading-6 text-gray-900">
                        Privacy
                      </h2>
                      <p className="mt-1 text-sm text-gray-500">
                        Ornare eu a volutpat eget vulputate. Fringilla commodo amet.
                      </p>
                    </div> */}
          <ul role="list" className=" divide-y divide-gray-200">
            <Switch.Group
              as="li"
              className="flex items-center justify-between py-4"
            >
              <div className="flex flex-col">
                <Switch.Label
                  as="p"
                  className="text-sm font-medium text-gray-900"
                  passive
                >
                  {t('settings.autoAcceptJobsTitle')}
                </Switch.Label>
                <Switch.Description className="text-sm text-gray-500">
                  {t('settings.autoAcceptJobsDesc')}
                </Switch.Description>
              </div>
              <Switch
                checked={autoAcceptJobs}
                onChange={setAutoAcceptJobs}
                className={classNames(
                  autoAcceptJobs ? "bg-indigo-500" : "bg-gray-200",
                  "relative ml-4 inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
                )}
              >
                <span
                  aria-hidden="true"
                  className={classNames(
                    autoAcceptJobs ? "translate-x-5" : "translate-x-0",
                    "inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                  )}
                />
              </Switch>
            </Switch.Group>
          </ul>
        </div>
        <div className="mt-4 flex justify-end py-4 px-4 sm:px-6">
          <button
            type="button"
            className="inline-flex justify-center rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
          >
            {t('cancel')}
          </button>
          <button
            type="submit"
            className="ml-5 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-sky-800 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
            onClick={saveSettings}
          >
            {isSaving ? t('saving') : t('save')}
          </button>
        </div>
      </div>
    </SettingsLayout>
  );
}